import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import UploadDocumentsAssetStyle from "../../../../Components/UploadDocuments/UploadDocumentsAssetStyle";
import { BombiixModal } from "../../../../Components/BombiixModal";

function UploadCareLayoutPDF({ showUpload, devOrderId, submitData, submitDisable }) {
  const { t } = useTranslation("common");
  const docRef = useRef();

  const handleSubmit = () => {
    const selected = docRef.current?.selectedDocument();
    if (selected) {
      submitData(selected);
    }
  };

  return (
    <BombiixModal
      show={showUpload}
      onClose={() => submitData("close")}
      onSave={handleSubmit}
      saveLabel={t("COMMON_LABEL.SAVE")}
      saveDisabled={submitDisable}
      title={t("TAKING_DATES.UPLOAD_PDF")}
      className="asset-style-modal-dialog"
    >
      <UploadDocumentsAssetStyle
        ref={docRef}
        module="careLabel"
        productId={devOrderId}
        accept=".pdf"
        showAddToAssetLibrary
        onSelectedGradingGroupChange={() => {}}
        setShowGradingGroupError={() => {}}
      />
    </BombiixModal>
  );
}

export default UploadCareLayoutPDF;
